module.exports = __webpack_public_path__ + "static/media/8S.d538e23f.svg";